import styled from '@mint-lib/styled';

import Icon from '../Icon/Icon.jsx';
import TableBodyCell, {
  TableBodyCellProps,
} from '../TableBodyCell/TableBodyCell.jsx';

export interface TableCellDraggableProps extends TableBodyCellProps {
  bgColor?: TableBodyCellProps['bgColor'];
  readOnly?: boolean;
  children?: TableBodyCellProps['children'];
}

const TableCellDraggable = ({
  bgColor = 'default',
  readOnly,
  children,
  ...props
}: TableCellDraggableProps) => {
  return (
    <StyledTableCell
      bgColor={bgColor}
      aria-label="table-cell-draggable"
      {...props}
    >
      <Icon
        component="Draggable"
        aria-label="icon-draggable"
        className={readOnly ? '' : 'icon-draggable'}
        sx={{
          visibility: 'hidden',
          color: 'icon.secondary',
        }}
      />
      {children}
    </StyledTableCell>
  );
};

export default TableCellDraggable;

const StyledTableCell = styled(TableBodyCell)({
  '&:hover': {
    '& .icon-draggable': {
      visibility: 'visible',
    },
  },
  padding: '0 0 0 4px !important',
  width: '20px !important',
  height: '40px !important',
  flexShrink: 0,
});
